import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/builder-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-0d0df700"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchbox" }
const _hoisted_2 = { class: "showtag" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"15px","height":"15px"}
}, null, -1))
const _hoisted_4 = { class: "showtag-num" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "mapDiv",
  class: "map"
}, null, -1))
const _hoisted_6 = { class: "swiprbox" }
const _hoisted_7 = {
  class: "swipe-item",
  style: {"height":"115px","width":"122px","margin":"0 0 0 auto","border-radius":"6px"}
}
const _hoisted_8 = {
  class: "swipe-item-img",
  style: {"height":"75px","width":"100%"}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  class: "swipe-item-info",
  style: {"padding":"4px","box-sizing":"border-box"}
}
const _hoisted_11 = { class: "swipe-item-name" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = {
  class: "status",
  style: {"margin-left":"10px"}
}
const _hoisted_14 = { class: "swipe-item-area" }
const _hoisted_15 = { class: "custom-indicator" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mapbox", _ctx.classList]),
    onTouchstart: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.touchStart && _ctx.touchStart(...args)), ["self"])),
    onTouchmove: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.touchMove && _ctx.touchMove(...args)), ["self"])),
    onAnimationend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.animationend && _ctx.animationend(...args)))
  }, [
    _createVNode(_component_van_nav_bar, {
      title: "工程项目",
      fixed: "",
      placeholder: ""
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_search, {
        placeholder: "请输入搜索关键词",
        modelValue: _ctx.searchParams,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchParams) = $event))
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.projectInfoList.length), 1)
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_van_swipe, {
        loop: false,
        width: 130,
        ref: "projectSwipe",
        onChange: _ctx.fSwipeChange
      }, {
        indicator: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.current + 1) + "/" + _toDisplayString(_ctx.projectList.length), 1)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectInfoList, (project, index) => {
            return (_openBlock(), _createBlock(_component_van_swipe_item, {
              key: index,
              onClick: ($event: any) => (_ctx.onClickSwipe(project))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (project.mapFileUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: 
                  project.mapFileUrl +
                  '?x-oss-process=image/resize,m_fill,h_100,w_200'
                ,
                          style: {"width":"100%","height":"100%"}
                        }, null, 8, _hoisted_9))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(project.name), 1),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["dot", {
                      _finish: project.status === 2,
                    }])
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(project.status === 2 ? "已竣工" : "在建"), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, "面积:" + _toDisplayString(project.area), 1)
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["onChange"])
    ])
  ], 34))
}